// passenger-selection.component.ts
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Passenger } from '../../_models/Passenger';

@Component({
  selector: 'app-passenger-selection',
  templateUrl: './passenger-selection.component.html',
  styleUrl: './passenger-selection.component.scss',
  standalone: true,
  imports: [],
})
export class PassengerSelectionComponent implements OnInit, OnChanges {
  @Input() passengers: Passenger[] = [];
  @Input() multiSelect: boolean = false;
  @Output() selectionChange = new EventEmitter<Passenger[]>();
  @Input() selectedPassengers: Passenger[] = [];
  @Output() selectedPassengersChange = new EventEmitter<Passenger[]>();
  selectedPassengerIds: Set<string> = new Set();

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedPassengers']) {
      if (this.selectedPassengers) {
        this.selectedPassengerIds = new Set(
          this.selectedPassengers.map((p) => p.id_passenger.toString())
        );
      }
    }
  }

  togglePassenger(passengerId: string): void {
    if (this.multiSelect) {
      if (this.selectedPassengerIds.has(passengerId)) {
        if (this.selectedPassengerIds.size > 1) {
          this.selectedPassengerIds.delete(passengerId);
        }
      } else {
        this.selectedPassengerIds.add(passengerId);
      }
    } else {
      this.selectedPassengerIds.clear();
      this.selectedPassengerIds.add(passengerId);
    }

    this.emitSelectedPassengers();
  }

  isSelected(passengerId: string): boolean {
    return this.selectedPassengerIds.has(passengerId);
  }

  private emitSelectedPassengers(): void {
    const selectedPassengers = this.passengers.filter((p) =>
      this.selectedPassengerIds.has(p.id_passenger.toString())
    );

    this.selectionChange.emit(selectedPassengers);
    this.selectedPassengersChange.emit(selectedPassengers);
  }
}
